import React, { useRef } from "react";
import styles from '../styles/studentservices.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import WebinarEvents from "./WebinarEvents";
import FeaturedBlogs from "./FeaturedBlogs";
import CustomImage from "./CustomImage"; 
import CommonQuestionsPage from "./commonQuestions";
import Testimonial from "./Testimonial";
import TopTieUpsOfKC from "./UniTieUp";
import SeveneasySteps from "./SeveneasySteps";
import KcNewLatestUpdates from "./kcNewlatestupdates";
import { isFrappeOrJotFormClass } from "../utils/helpers";
import { useRouter } from "next/router";
import { getOnboardingOrFormCtaProps } from "../utils/applyCtaButtonProps";
import { persistSourceContext } from "../utils/b2c/sourceTracking";
import { PRIMARY_SOURCE_B2C_WIDGET } from "../utils/b2c/constants";

const ServicesStudentPage: React.FC = (props: any) => {
  const router = useRouter();
  const sliderRef = useRef<Slider>(null);
  var settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
  };

  const servicesStudentData = props.pageData;
  const heroToOnboardingEnabled = servicesStudentData?.heroSectionBtn?.toOnboardingEnabled;
  const applyCtaButtonProps = getOnboardingOrFormCtaProps(router, {
    btnLink: servicesStudentData?.heroSectionBtn?.btnLink,
    formId: servicesStudentData?.heroSectionBtn?.formId || (heroToOnboardingEnabled ? undefined : 'main-enquiry-form'),
    toOnboardingEnabled: heroToOnboardingEnabled,
  });

  const renderService = (service: any) => {
    return (
      <>
        <Col lg={6} md={6} xs={12}>
          <div id="servc-studnt">
            <CustomImage src={service?.newImagePath?.imageUrl} alt={service?.newImagePath?.alt} width={540} height={400} />
          </div>
        </Col>
        <Col lg={6} md={6} xs={12}>
          <div id="servc-studnts">
            <h2 className="subHeadStyle">{service.title}</h2>
            <p className="subHeadPara">{service.description}</p>
            <h6 className="subHeadSub">Offerings</h6>
            <ul className="pl-0">
              {
                service?.offerings?.length > 0 &&
                service?.offerings.map((offer: string, index: number) => <li key={index} className="subHeadUlLi">{offer}</li>)
              }
            </ul>
            {renderLinks(service.links)}
          </div>
        </Col>
      </>
    )
  }

  const linkClickHandler = (link: any) => (e: any) => {
    if (link.href) {
      window.open(link.href);
      return;
    }

    if(props?.pageData?.meta?.jotforms[0]?.jotformid) {
      return;
    }

    if(link?.toOnboardingEnabled) {
      persistSourceContext({
        sourceUrl: window.location.href,
        primarySource: PRIMARY_SOURCE_B2C_WIDGET,
        fifthStepVisible: link?.onBoardingFlow?.nearestOffice ?? true,
        coachingVisible: link?.onBoardingFlow?.lookingForCoaching ?? true, // CFM-1514
      });

      
      window.location.href = "/onboarding?source_url=student-services/steps-to-study-abroad";
    }
  }

  const renderLinks = (links: any) => {
    return (
      links.map((link: any) => {
        return (
          <>
            {
              link.type === 'one'
                ? <div className={`subAnchor contBtn ${!link.href ? `btn ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}` : ''}`}
                  onClick={linkClickHandler(link)}>
                  {link.label}
                </div>
                : <a href={link.href} className={styles.knowMore}>{link.label}</a>
            }
          </>
        )
      })
    )
  }

  const enquireNowClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (applyCtaButtonProps.mode === "onboarding") {
      persistSourceContext({
        sourceUrl: window.location.href,
        primarySource: PRIMARY_SOURCE_B2C_WIDGET,
        fifthStepVisible: servicesStudentData?.heroSectionBtn?.onBoardingFlow?.nearestOffice ?? true,
        coachingVisible: servicesStudentData?.heroSectionBtn?.onBoardingFlow?.lookingForCoaching ?? true, // CFM-1514
      });
    }
    
    applyCtaButtonProps.onClick?.(e)
  };

  return (
    <div className={styles.studentServicesPage}>

      <div className={styles.studentServicesCurve}>
        <div className={styles.contentDiv}>
          <Container>
            <Row>
              <Col lg={6} md={6} xs={12}>
                <div className="d-block d-sm-none ">
                  <div className="d-flex justify-content-center">
                    <Breadcrumb className={styles.mobileBreadCrum}>
                      <Breadcrumb.Item href="/" style={{ opacity: 0.5 }}>
                        Services
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href="" >
                        For Students
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                  <CustomImage src={props.pageData.mainImageUrl || "/images/home-page-service-1.svg"} alt="home-page-service" width={540} height={400} />
                </div>
                <div className={styles.servContent}>
                  <Breadcrumb className="d-none d-sm-block">
                    <Breadcrumb.Item href="/" style={{ opacity: 0.5 }}>
                      Services
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="" >
                      For Students
                    </Breadcrumb.Item>
                  </Breadcrumb>
                  <h1>{props?.pageData?.title}</h1>
                  <p>{props?.pageData?.description}</p>
                  <button onClick={enquireNowClickHandler} className={`${styles.enquirebtn} ${`btn ${applyCtaButtonProps.formClassName}`}`}>
                    {servicesStudentData?.heroSectionBtn?.label || 'Enquire Now'}
                  </button>
                </div>
              </Col>
              <Col lg={6} md={6} xs={12}>
                <div className="d-none d-sm-block text-center">
                  <CustomImage src={props.pageData.newmainImageUrl?.imageUrl || "/images/home-page-service-1.svg"} alt={props.pageData.newmainImageUrl?.alt} width={540} height={400} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className={styles.WhyKc}>
        <Container>
          <Row>
            <div className="text-center">
              <h2>Why KC?</h2>
            </div>
          </Row>
          <Row>
            {
              props?.pageData?.whyKc?.length > 0 &&
              props?.pageData?.whyKc.map((kcBenefit: any) => {
                return (
                  <Col xl={4} md={4} xs={12}>
                    <div className="text-center mb-3">
                      <div className={styles.img}>
                        <CustomImage src={kcBenefit?.imagePath} alt={kcBenefit?.ImageAltTag} width={107} height={76} />
                      </div>
                      <h6>{kcBenefit?.title}</h6>
                      <p>{kcBenefit?.description}</p>
                    </div>
                  </Col>
                )
              })
            }
          </Row>
        </Container>
      </div>

      <div className={styles.studentHelpMainDiv}>
        <Container>
          <h2 className="text-center">How do we help students?</h2>
        </Container>
        <div className="desktop d-none d-sm-block">
          {
            props?.pageData?.studentServices?.length > 0 &&
            props?.pageData?.studentServices.map((service: any, index: number) => {
              return (
                <div className={styles.studentHelp} key={index}>
                  <span className={styles.alignTop} id={`${index + 1}`} />
                  <Container>
                    <Row>
                      {(index + 1) % 2 === 0
                        ? <>
                          <Col lg={6} md={6} xs={12}>
                            <div>
                              <h2 className="subHeadStyle">{service.title}</h2>
                              <p className="subHeadPara">{service.description}</p>
                              <h6 className="subHeadSub">Offerings</h6>
                              <ul className="pl-0">
                                {
                                  service?.offerings?.length > 0 &&
                                  service?.offerings.map((offer: string, index: number) => <li key={index} className="subHeadUlLi">{offer}</li>)
                                }
                              </ul>
                              <div className={styles.linksDiv}>
                                {renderLinks(service.links)}
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={6} xs={12}>
                            <div>
                              <CustomImage src={service?.newImagePath?.imageUrl} alt={service?.newImagePath?.alt} width={540} height={400} />
                            </div>
                          </Col>
                        </>
                        : renderService(service)
                      }
                    </Row>
                  </Container>
                </div>
              )
            })
          }
        </div>

        {/* mobile view */}
        <div className="mobile d-block d-sm-none">
          <Container>
            <div>
              <Slider {...settings} ref={sliderRef} className={styles.slider}>
                {props?.pageData?.studentServices?.length > 0 &&
                  props?.pageData?.studentServices.map((service: any, index: number) => {
                    return (<div className={styles.studentHelp}>
                      <Container>
                        <Row>
                          {renderService(service)}
                        </Row>
                      </Container>
                    </div>)
                  })
                }
              </Slider>
              <div className={styles.arrowsClasses}>
                <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                  <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                </div>
                <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                  <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <div className={styles.studentServicesWebinarEvent}>
        <WebinarEvents headingLevel={2}/>
      </div>

      <div className={styles.sevenBG}>
        <SeveneasySteps />
      </div>


      <div className={styles.studentTieUpsUni}>
        <TopTieUpsOfKC />
      </div>

      <div className={styles.studentCommonQues}>
        {props?.pageData?.commonQuestions?.length > 0 &&
          <CommonQuestionsPage data={props?.pageData?.commonQuestions} />
        }
      </div>

      <Testimonial title='What our students say about us?' bgColor='#FFFFFF' slug='student-testimonials?_limit=15&_sort=id:DESC' />

      <div className={styles.studentServicesKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>

      <div className={styles.StudentBlogs}>
        <FeaturedBlogs />
      </div>

      <div className="d-none d-sm-block">
        <div className={styles.studentFooter}>
          <Container>
            <Row>
              <Col>
                <div className={styles.session}>
                  <div>
                    <h3>Start your Study Abroad Journey with KC </h3>
                    <p>Book a free in person or virtual counselling session with our experts now!</p>
                  </div>
                  <div className={styles.anchor}>
                    <a href="/contact-us" className="btn btn-primary">Contact Us</a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  )

}
export default ServicesStudentPage;